// ===== TOGGLE ACORDEÃO =====
function tgToggle(id) {
  var el = document.getElementById(id);
  if (!el) return;
  var aberto = el.style.display !== 'none';
  el.style.display = aberto ? 'none' : 'block';
}

// ===== TOGGLE BLOCOS FRETE/CUPOM =====
function tgToggleBloco(abrir, fechar, blocoAbrir, blocoFechar) {
  var elAbrir = document.getElementById(abrir);
  var elFechar = document.getElementById(fechar);
  var bAbrir = document.getElementById(blocoAbrir);
  var bFechar = document.getElementById(blocoFechar);

  if (!elAbrir) return;

  var jaAberto = elAbrir.style.display === 'block';

  if (elFechar) elFechar.style.display = 'none';
  if (bFechar) bFechar.classList.remove('ativo');

  if (jaAberto) {
    elAbrir.style.display = 'none';
    if (bAbrir) bAbrir.classList.remove('ativo');
  } else {
    elAbrir.style.display = 'block';
    if (bAbrir) bAbrir.classList.add('ativo');
  }
}

// ===== MÁSCARA CEP =====
document.addEventListener('input', function(e) {
  if (e.target && (e.target.id === 'tg-cep-drawer' || e.target.id === 'tg-cep-cart' || e.target.id === 'tg-cep-pdp')) {
    var v = e.target.value.replace(/\D/g, '').slice(0, 8);
    if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
    e.target.value = v;
  }
});

// ===== BUSCAR FRETE =====
function tgBuscarFrete(ctx) {
  var cepEl = document.getElementById('tg-cep-' + ctx);
  var cidadeEl = document.getElementById('tg-cep-cidade-' + ctx);
  var listaEl = document.getElementById('tg-frete-lista-' + ctx);
  var cep = cepEl.value.replace(/\D/g, '');

  if (cep.length !== 8) {
    cidadeEl.textContent = 'CEP inválido. Digite 8 números.';
    cidadeEl.style.color = '#dc2626';
    return;
  }

  cidadeEl.textContent = 'Consultando...';
  cidadeEl.style.color = '';
  listaEl.innerHTML = '';

  fetch('https://viacep.com.br/ws/' + cep + '/json/')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.erro || !data.localidade) {
        cidadeEl.textContent = 'CEP não encontrado.';
        cidadeEl.style.color = '#dc2626';
        return;
      }

      cidadeEl.textContent = data.localidade + ' - ' + data.uf;
      cidadeEl.style.color = '';
      listaEl.innerHTML = '<div style="font-size:11px;opacity:0.5;margin-bottom:6px">Calculando fretes...</div>';

      fetch('/cart/shipping_rates.json?shipping_address[zip]=' + cep + '&shipping_address[country]=BR&shipping_address[province]=' + data.uf)
        .then(function(r) { return r.json(); })
        .then(function(result) {
          var rates = result.shipping_rates;
          if (!rates || rates.length === 0) {
            listaEl.innerHTML = '<div style="font-size:12px;opacity:0.6">Frete calculado no checkout.</div>';
            return;
          }
          var html = '';
          rates.forEach(function(rate) {
            var preco = parseFloat(rate.price);
            var precoStr = preco === 0 ? 'Grátis' : 'R$ ' + preco.toFixed(2).replace('.', ',');

            var prazo = '';
            if (rate.delivery_date) {
              var hoje = new Date();
              hoje.setHours(0,0,0,0);
              var partes = rate.delivery_date.split('-');
              var entrega = new Date(partes[0], partes[1]-1, partes[2]);
              var diff = Math.round((entrega - hoje) / (1000 * 60 * 60 * 24));
              if (diff <= 0) {
                prazo = 'Chega hoje';
              } else if (diff === 1) {
                prazo = 'Chega amanhã';
              } else {
                prazo = 'Chega em ' + diff + ' dias úteis';
              }
            }

            html += '<div class="tg-frete-opcao">';
            html += '<div class="tg-frete-info">';
            html += '<span class="tg-frete-nome">' + rate.name + '</span>';
            if (prazo) html += '<span class="tg-frete-prazo">' + prazo + '</span>';
            html += '</div>';
            html += '<span class="tg-frete-preco' + (preco === 0 ? ' tg-frete-gratis' : '') + '">' + precoStr + '</span>';
            html += '</div>';
          });
          listaEl.innerHTML = html;
        })
        .catch(function() {
          listaEl.innerHTML = '<div style="font-size:12px;opacity:0.6">Frete calculado no checkout.</div>';
        });
    })
    .catch(function() {
      cidadeEl.textContent = 'Erro ao consultar CEP.';
      cidadeEl.style.color = '#dc2626';
    });
}

// ===== SALVAR CUPOM =====
function tgSalvarCupom(ctx) {
  var input = document.getElementById('tg-cupom-' + ctx);
  var msg = document.getElementById('tg-cupom-msg-' + ctx);
  var codigo = input.value.trim().toUpperCase();

  msg.className = 'tg-calc-msg';
  msg.style.display = 'none';

  if (!codigo) {
    msg.className = 'tg-calc-msg erro';
    msg.style.display = 'block';
    msg.textContent = 'Digite um código de cupom.';
    return;
  }

  window.tgCupomAplicado = codigo;

  msg.className = 'tg-calc-msg sucesso';
  msg.style.display = 'block';
  msg.innerHTML = '✓ Cupom <strong>' + codigo + '</strong> enviado! Se válido, o desconto será aplicado automaticamente no checkout.';

  document.querySelectorAll('button[name="checkout"], a[href*="/checkout"]').forEach(function(btn) {
    if (btn.tagName === 'A') {
      btn.href = '/checkout?discount=' + encodeURIComponent(codigo);
    } else {
      btn.onclick = function(e) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(codigo);
      };
    }
  });
}